import { Toasts } from 'components'
import { FormHelpers } from 'utility/form-helpers'
import { validateInput, validateInputs } from 'utility/form-validation'
import { WarningIcon } from '../icons'

const el = {
  root: document.querySelector('.checkout-layout--information'),
  toggleCard: document.querySelector<HTMLInputElement>(
    '.checkout-layout--information .toggle-card input'
  ),
  shippingForm: document.querySelector<HTMLDivElement>('.checkout-layout__shipping-form'),
  proceedButtons: document.querySelectorAll<HTMLButtonElement>(
    '#checkout-sidebar-proceed-button, #checkout-footer-proceed-button'
  ),
  billingFormInputs: document.querySelectorAll<HTMLInputElement>('#billing-form input'),
  shippingFormInputs: document.querySelectorAll<HTMLInputElement>('#shipping-form input'),
  forms: document.querySelectorAll<HTMLFormElement>(
    '#checkout-information-form, #checkout-information-form-mobile'
  ),
}

export const CheckoutInformation = {
  init: () => {
    if (!el.root || !el.toggleCard || !el.shippingForm || !el.forms.length) return
    if (el.toggleCard.checked) CheckoutInformation.openShippingForm()
    el.toggleCard.addEventListener('change', CheckoutInformation.toggleShippingForm)
    el.billingFormInputs.forEach((field) =>
      field.addEventListener('blur', CheckoutInformation.onTouched)
    )
    el.shippingFormInputs.forEach((field) =>
      field.addEventListener('blur', CheckoutInformation.onTouched)
    )
    el.billingFormInputs.forEach((field) =>
      field.addEventListener('input', CheckoutInformation.onChange)
    )
    el.shippingFormInputs.forEach((field) =>
      field.addEventListener('input', CheckoutInformation.onChange)
    )
    el.forms.forEach((target) =>
      target.addEventListener('submit', CheckoutInformation.onSubmit)
    )
    CheckoutInformation.toggleProceedButtonState()
  },

  toggleShippingForm: (e: Event & { target: HTMLInputElement }) => {
    if (!e.target.checked) {
      CheckoutInformation.closeShippingForm()
    } else {
      CheckoutInformation.openShippingForm()
    }
    CheckoutInformation.toggleProceedButtonState()
  },

  toggleProceedButtonState: () => {
    const isFormValid = CheckoutInformation.validateForm({ showErrors: false })
    if (!isFormValid) {
      el.proceedButtons.forEach((target) => (target.disabled = true))
      return
    }
    el.proceedButtons.forEach((target) => (target.disabled = false))
  },

  openShippingForm: () => {
    if (!el.shippingForm) return
    el.shippingForm.classList.add('checkout-layout__shipping-form--visible')
    el.shippingFormInputs.forEach((target) => (target.required = true))
  },

  closeShippingForm: () => {
    if (!el.shippingForm) return
    el.shippingForm.classList.remove('checkout-layout__shipping-form--visible')
    el.shippingFormInputs.forEach((target) => {
      target.required = false
      target.value = ''
    })
  },

  validateForm: ({ showErrors = false }) => {
    const inputsToValidate = CheckoutInformation.getInputsToValidate()
    return validateInputs({ inputs: inputsToValidate, showErrors })
  },

  onTouched: (e: Event & { target: HTMLInputElement }) => {
    if (!e.target.classList.contains('touched')) {
      e.target.classList.add('touched')
    }
  },

  onChange: (e: Event & { target: HTMLInputElement }) => {
    if (e.target.classList.contains('autovalidate')) {
      validateInput({ input: e.target, showError: true })
    }
    CheckoutInformation.toggleProceedButtonState()
  },

  getInputsToValidate: () => {
    let inputsToValidate = Array.from(el.billingFormInputs)
    if (CheckoutInformation.isShippingFormOpen()) {
      inputsToValidate = inputsToValidate.concat(Array.from(el.shippingFormInputs))
    }
    return inputsToValidate
  },

  onSubmit: async (e: Event & { target: HTMLFormElement }) => {
    e.preventDefault()

    const isValidForm = CheckoutInformation.validateForm({ showErrors: true })
    if (!isValidForm) return

    FormHelpers.submitForm({
      form: el.forms[0],
      buttons: Array.from(el.proceedButtons),
      onSuccess: () => (window.location.href = CheckoutInformation.getRedirectUrl()),
      onError: () =>
        Toasts.addToast({
          title: 'Villa kom upp!',
          text: 'Ekki tókst að vista notendaupplýsingar',
          icon: WarningIcon(),
        }),
    })
  },

  isShippingFormOpen: () =>
    document.querySelector('.checkout-layout__shipping-form--visible'),

  getRedirectUrl: () =>
    document.querySelector<HTMLButtonElement>('#checkout-sidebar-proceed-button')?.dataset
      .href || '',
}
